import { Suspense } from 'react';
import { useRSimLastPoolingTimestamp } from './hooks/useRSimLastPollingTimestamp';
import { useTranslation } from 'react-i18next';
import { SectionGridItem } from 'src/common/components/SectionGrid/SectionGridItem';
import Skeleton from '@mui/material/Skeleton';
import { parseResponseDateAndTime } from 'src/common/utils/parseResponseDate';

const RSimLastPoolingContent = ({ euicc }: { euicc: string }) => {
  const { data: timestamp } = useRSimLastPoolingTimestamp(euicc);
  const { t } = useTranslation();

  return (
    <SectionGridItem
      value={
        timestamp?.lastPollingTimestamp
          ? parseResponseDateAndTime(timestamp.lastPollingTimestamp)
          : null
      }
      label={t('rSimInventory.lastPolling')}
      testId="lastPolling"
    />
  );
};

export const RSimLastPooling = ({ euicc }: { euicc: string }) => {
  const { t } = useTranslation();
  return (
    <Suspense
      fallback={
        <SectionGridItem label={t('rSimInventory.lastPolling')} testId="lastPolling">
          <Skeleton height={24} data-testid="skeleton-details" />
        </SectionGridItem>
      }
    >
      <RSimLastPoolingContent euicc={euicc} />
    </Suspense>
  );
};
